import styles from './explorer-setting.module.scss';
import { useState, type FC } from 'react';
import settingIcon from '@assets/images/parrot/setting.svg';
import SettingContent from './setting-content';
import Popover from '@ui/parrot/popover';

export const ExplorerSetting: FC = () => {
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      content={<SettingContent />}
      trigger={'click'}
      open={visible}
      onOpenChange={setVisible}
      placement="bottomRight"
    >
      <div className={styles.wrapper}>
        <img src={settingIcon} />
      </div>
    </Popover>
  );
};
